import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { TableHeaderCellProvider } from '../TableHeaderCell/TableHeaderCell.context';
import { StyledTableBody } from './TableBody.styles';

/**
 * A native [`<tbody>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/tbody) element.
 *
 * @since 8.0.0
 */

export var TableBody = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(TableHeaderCellProvider, {
    value: {
      parent: 'body'
    }
  }, /*#__PURE__*/React.createElement(StyledTableBody, _extends({
    ref: forwardedRef
  }, props)));
});
TableBody.displayName = 'Table.Body';